import type { FC } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Dialog, DialogContent } from '@crehana/ui';

export interface NotificationDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  cancelLabel?: string;
  confirmLabel?: string;
  onDismiss(): void;
  onClick(): void;
  isDark: boolean;
  type: 'simple-confirmation' | 'alert-confirmation';
}

const NotificationDialog: FC<NotificationDialogProps> = ({
  isOpen,
  title,
  message,
  cancelLabel,
  confirmLabel,
  onDismiss,
  onClick,
  isDark,
  type = 'simple-confirmation',
}) => {
  return (
    <Dialog onDismiss={onDismiss} open={isOpen} size="s">
      <DialogContent
        mainTitle={title}
        body={message}
        cancelAction={
          cancelLabel ? (
            <button
              type="button"
              className="tw-btn-inverse-m"
              onClick={onDismiss}
            >
              {cancelLabel}
            </button>
          ) : undefined
        }
        className="-mt-32 sm:px-12 md:px-20 px-24"
        confirmAction={
          confirmLabel ? (
            <button
              className={
                type === 'simple-confirmation'
                  ? 'tw-btn-primary-m'
                  : 'tw-btn-deactivate-m'
              }
              type="submit"
              onClick={onClick}
            >
              {confirmLabel}
            </button>
          ) : undefined
        }
        isDark={isDark}
      />
    </Dialog>
  );
};

export default NotificationDialog;
